import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { useSmsAgentOps } from './useSmsAgentOps'
import { SmsAgentOpsComponent } from './SmsAgentOpsComponent'

/**
 * Ops tab body for the SMS Agent page (super users only; the page only offers the tab
 * to them). An `observer`, because `useSmsAgentOps` reads `SmsAgentOpsStore` observables
 * during this render: loading a scope, or picking a filter, re-renders here.
 */
export const SmsAgentOpsTab = observer(function SmsAgentOpsTab(): ReactElement {
  const hookData = useSmsAgentOps()
  return <SmsAgentOpsComponent {...hookData} />
})
